import { render, staticRenderFns } from "./FrontEndLayout.vue?vue&type=template&id=0bb50ff5&"
import script from "./FrontEndLayout.vue?vue&type=script&lang=js&"
export * from "./FrontEndLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports